export function isIOSDevice() {
  const platform = navigator.userAgentData?.platform || navigator.platform;
  return [
    'iPad Simulator',
    'iPod Simulator',
    'iPad',
].includes(platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}